import { useLanguage } from './LanguageContext';

/** A plain EN / RU switch - two buttons, no dropdown, no flags/icons. */
export function LanguageToggle(): JSX.Element {
  const { locale, setLocale } = useLanguage();

  return (
    <div className="lang-toggle" role="group" aria-label="Language">
      <button
        type="button"
        className={locale === 'en' ? 'active' : ''}
        aria-pressed={locale === 'en'}
        onClick={() => setLocale('en')}
      >
        EN
      </button>
      <button
        type="button"
        className={locale === 'ru' ? 'active' : ''}
        aria-pressed={locale === 'ru'}
        onClick={() => setLocale('ru')}
      >
        RU
      </button>
    </div>
  );
}
